import { createStandaloneToast } from '@chakra-ui/react';

const { toast } = createStandaloneToast();

const baseOptions = {
	duration: 4000,
	isClosable: true,
	position: 'top-right' as const
};

export const toastService = {
	success(message: string, title = 'Sucesso') {
		toast({ ...baseOptions, title, description: message, status: 'success' });
	},
	error(message: any, title = 'Erro') {
		const description = typeof message === 'string' ? message : message?.message || 'Ocorreu um erro inesperado.';
		toast({ ...baseOptions, title, description, status: 'error' });
	},
	info(message: string, title = 'Info') {
		toast({ ...baseOptions, title, description: message, status: 'info' });
	},
	warning(message: string, title = 'Atenção') {
		toast({ ...baseOptions, title, description: message, status: 'warning' });
	}
};
